"use strict";

/**
 * Returns true if `val` is true or equal to string 'true'
 *
 * @param val
 * @returns {boolean}
 *
 * @example
 *
 *      isTrue(true) // => true
 *      isTrue('true') // => true
 *      isTrue([true]) // => false
 *      isTrue('false') // => false
 */
module.exports = function (val) {
  return val === true || val === 'true';
};